var scope_0 = require('/home/runner/work/tattle-api/tattle-api/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c118ea17c59dac135d362eb64c5bb47d.js').default;
var scope_1 = require('/home/runner/work/tattle-api/tattle-api/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/de2c9b78f2d76be1d48ddd43bc8ea853.js').default;
var scope_2 = require('/home/runner/work/tattle-api/tattle-api/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    